import {getLanguage, getPriorityVersion} from '../_shared/GWTBridge/invoke/common';
import {DocType} from '../_shared/Help/types';

//for testing xpert error
const simulateXpertError = window.location.search.includes('_xpertError');
const baseUrl = simulateXpertError
    ? 'https://xpertapii.priority-software.com/api/DocumentSearch/'
    : 'https://xpertapi.priority-software.com/api/DocumentSearch/';
const postRequestOptions = data => ({
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(data)
});

export function getVersion() {
    const serverVersion = getPriorityVersion();
    const version = serverVersion.toString();
    return version.slice(0, 2) + '.0' + version.slice(2, 3);
}

export type getDataProps = {formName?: string; docType: DocType; searchString?: string};

export async function getDataByDocType({formName, docType, searchString}: getDataProps) {
    try {
        const reqData = {
            docTypes: [docType],
            languages: [getLanguage() === 1 ? 'Hebrew' : 'English'],
            enames: formName ? [formName] : [],
            versions: [
                '24.00'
                //getVersion()
            ],
            searchString
        };
        const res = await fetch(baseUrl + 'query', postRequestOptions(reqData));
        const data = await res.json();
        return data;
    } catch (error) {
        return;
    }
}

export async function getItemDetails(ID: string) {
    try {
        const res = await fetch(
            baseUrl + `getDetails?id=${ID}&language=${getLanguage() === 1 ? 'Hebrew' : 'English'}`
        );
        const json = await res.json();
        return json;
    } catch (error) {
        return null;
    }
}
